module.exports = __webpack_public_path__ + "static/media/wheel-balancing.800835e6.svg";